import React from 'react';

import ControlCenter from './ControlCenter';

const ControlCenterPageContainer = props => <ControlCenter {...props} />;

export default ControlCenterPageContainer;
